type AuxDeviceAddressType = 'network' | 'bluetooth' | undefined;

interface AuxDeviceAddressMeta {
    value: string | undefined;
    type: AuxDeviceAddressType;
}

const IPV4_REGEX =
    /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;
const IPV4_WITH_PORT_REGEX =
    /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}:(6553[0-5]|655[0-2]\d|65[0-4]\d{2}|6[0-4]\d{3}|[1-5]\d{4}|[1-9]\d{0,3})$/;
const MAC_REGEX = /^([0-9A-F]{2}[:-]){5}([0-9A-F]{2})$/i;

export const getAuxDeviceAddressMeta = (
    address?: string | null,
): AuxDeviceAddressMeta => {
    const raw = typeof address === 'string' ? address.trim() : '';

    if (!raw) {
        return {
            value: undefined,
            type: undefined,
        };
    }

    if (IPV4_REGEX.test(raw) || IPV4_WITH_PORT_REGEX.test(raw)) {
        return {
            value: raw,
            type: 'network',
        };
    }

    if (MAC_REGEX.test(raw)) {
        return {
            value: raw.toUpperCase(),
            type: 'bluetooth',
        };
    }

    return {
        value: raw,
        type: undefined,
    };
};
